/**
 * Re-export shim. The `ProgramProgress` **View** (props-only) was hoisted into
 * `@solomon-apps/shared/src/widgets/yaas/programs` so external consumers (the
 * "+New Program" Viewing-Program wiki doc) can render the bare budget/timeline
 * progress meters fixture-driven, with no wallet / RPC / orgApiFetch.
 *
 * The data-owning Container (`ProgramProgressContainer`) stays app-side — it
 * still derives the meter specs from the mock participant helpers and imports
 * this View from this path unchanged.
 *
 * @see packages/shared/src/widgets/yaas/programs/ProgramProgress.tsx
 */
export {
    ProgramProgress,
    type ProgramProgressProps,
    type ProgramMeter
} from "@solomon-apps/shared/src/widgets/yaas/programs/ProgramProgress";
